export default "__VITE_ASSET__BPl$A3s___"